import React from "react";
import PropTypes from "prop-types";
import Contain from "~components/atoms/contain/contain";
import RscHbSideNav from "~components/molecules/rsc_hb_side_nav/rsc_hb_side_nav";
import useMatchMedia from "~hooks/use_match_media/use_match_media";
import { LINK } from "../../../prop_types";
import getSearchIndices from "./helper_functions/get_search_indices/get_search_indices";
import {
  pageWrapperContentStyle,
  pageWrapperInnerStyle,
  pageWrapperOuterStyle,
} from "./rsc_hb_page_wrapper.module.scss";

export default function RscHbPageWrapper({
  children,
  items,
  lang,
  level1ActiveItem,
  level2ActiveItem,
  navigationConfig,
}) {
  const isDesktopWindow = useMatchMedia({ min: "XL" });

  const searchIndices = getSearchIndices({ lang });

  return (
    <>
      <div className={pageWrapperOuterStyle}>
        <Contain>
          <div className={pageWrapperInnerStyle}>
            {isDesktopWindow && (
              <RscHbSideNav
                {...{
                  items,
                  level1ActiveItem,
                  level2ActiveItem,
                  navigationConfig,
                  searchIndices,
                }}
              />
            )}
            <div className={pageWrapperContentStyle}>{children}</div>
          </div>
        </Contain>
      </div>
    </>
  );
}

RscHbPageWrapper.defaultProps = {
  items: [],
  level1ActiveItem: "",
  level2ActiveItem: "",
  children: null,
  lang: "en-gb",
};

RscHbPageWrapper.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({ title: PropTypes.string, link: LINK })
  ),
  level1ActiveItem: PropTypes.string,
  level2ActiveItem: PropTypes.string,
  children: PropTypes.node,
  lang: PropTypes.string,
  navigationConfig: PropTypes.shape({}).isRequired,
};
